import { spinner } from './Spinner.css';

interface SpinnerProps {
  /** `sm` (1rem, inline in buttons) or `md` (2rem, standalone). Default `sm`. */
  size?: 'sm' | 'md';
  /** Accessible status label (visually hidden is the caller's concern). */
  'aria-label'?: string;
  'aria-hidden'?: boolean;
  className?: string;
}

/**
 * Loading spinner — the vanilla-extract replacement for react-bootstrap's
 * `<Spinner animation="border">`. Inherits `currentColor` so it matches the
 * surrounding text/button. Renders `role="status"` unless `aria-hidden`.
 */
export function Spinner({ size = 'sm', className, 'aria-hidden': ariaHidden, 'aria-label': ariaLabel }: SpinnerProps) {
  return (
    <span
      className={[spinner[size], className].filter(Boolean).join(' ')}
      role={ariaHidden ? undefined : 'status'}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
    />
  );
}
